import PersonSection from "./PersonSection";

export default PersonSection;
